import angular from 'angular';
import ComponentsModule from '../../../components-module';
import logo from '../../../../images/atex-code-logo.svg';
import template from './code-head.html';

const COMPONENT_NAME = 'codeHead';

angular.module(ComponentsModule)
  .component (COMPONENT_NAME, {
    template,
    controller: ($location, $scope) => {
      let ctrl = $scope.$ctrl;

      ctrl.logo = logo;
      ctrl.home = () => $location.url('/');
    }
  });

export default COMPONENT_NAME;
